// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"filterToggle_wrapper__4vAaf","switch":"filterToggle_switch__BFwGd","slider":"filterToggle_slider__kXT13","round":"filterToggle_round__5e0GZ"};